export enum STATUS {
    IN_TRAINING = 'IN_TRAINING',
    RESIGNED = 'RESIGNED',
    PROCESS_EXIT = 'PROCESS_EXIT',
    CONFIRMED = 'CONFIRMED',
    CONFIRM = 'CONFIRM'

}